import React from 'react'
import { withRouter } from 'react-router-dom'
import * as request from 'superagent'
import { Document, Page } from 'react-pdf/build/entry.webpack'
import { Intent, Menu, MenuItem, MenuDivider, Button, NonIdealState, ProgressBar } from '@blueprintjs/core'
import { Toast } from '../../Toaster'
import { API_BASE_URL } from '../../index'

import './approve.css'

const getBlankCheques = (user) => {
  return new Promise(resolve => {
    request
      .post(API_BASE_URL + '/getBlankChequeUrls')
      .send({ user })
      .then((json) => {
        if (json.ok) {
          resolve(json.body)
        } else {
          throw new Error('Network failure')
        }
      })
      .catch(err => {
        console.log(err)
        resolve([])
      })
  })
}

function getIntent (approved) {
  if (typeof approved === 'undefined') {
    return null
  } else if (approved === true) {
    return Intent.SUCCESS
  } else {
    return Intent.DANGER
  }
}

function renderCheck (cheque, approved) {
  if (typeof cheque.approved === 'undefined') {
    return typeof approved === 'undefined'
  } else {
    return cheque.approved === approved
  }
}

const renderMenuItem = (setCurrent) => (approved, current) =>
(cheque, key) => (
  renderCheck(cheque, approved) &&
  <MenuItem key={key}
    intent={cheque.url === current
              ? Intent.PRIMARY
              : getIntent(approved)
    }
    text={cheque.name}
    iconName={
      typeof approved === 'boolean'
        ? approved
          ? 'endorsed'
          : 'ban-circle'
        : null
    }
    onClick={() => setCurrent(cheque.url)}
  />
)

const renderMenu = (setCurrent, submit) =>
(cheques, current) => (
  <Menu>
    {
      cheques.filter(cheque => typeof cheque.approved === 'undefined').length > 0 &&
      <div>
        <MenuDivider title='Todo' />
        { cheques.map(renderMenuItem(setCurrent)(undefined, current)) }
      </div>
    } {
      cheques.filter(cheque => cheque.approved === true).length > 0 &&
      <div>
        <MenuDivider title='Approved' />
        { cheques.map(renderMenuItem(setCurrent)(true, current)) }
      </div>
    } {
      cheques.filter(cheque => cheque.approved === false).length > 0 &&
      <div>
        <MenuDivider title='Rejected' />
        { cheques.map(renderMenuItem(setCurrent)(false, current)) }
      </div>
    } {
      cheques.length > 0 &&
      cheques.filter(cheque => typeof cheque.approved !== 'undefined')
        .length > 0 &&
        <div>
          <MenuDivider />
          <Button intent={Intent.PRIMARY}
            className='pt-large pt-fill'
            text='Submit!'
            iconName='cloud-upload'
            onClick={() => submit()}
          />
        </div>
    }
  </Menu>
)

class Approve extends React.Component {
  constructor () {
    super()
    this.state = {
      cheques: [],
      current: ''
    }

    this.setCurrent = this.setCurrent.bind(this)
    this.approveCurrent = this.approveCurrent.bind(this)
    this.rejectCurrent = this.rejectCurrent.bind(this)
    this.submit = this.submit.bind(this)
  }

  componentWillMount () {
    const role = this.props.role
    if (!role || !role.incl.includes('signingAuthority')) {
      this.props.history.push('/dash/')
    }

    getBlankCheques(this.props.user).then(cheques => {
      this.setState({
        cheques,
        current: (cheques[0] && cheques[0].url) || ''
      })
    })
  }

  setCurrent (url) {
    this.setState({
      current: url
    })
  }

  approveCurrent () {
    const cheques = this.state.cheques
    const currentIndex = cheques.findIndex(cheque => cheque.url === this.state.current)
    cheques[currentIndex] = Object.assign({}, cheques[currentIndex], { approved: true })

    let current = cheques.filter(cheque => typeof cheque.approved === 'undefined')[0]

    current = current ? current.url : ''

    this.setState({ cheques, current })
  }

  rejectCurrent () {
    const cheques = this.state.cheques
    const currentIndex = cheques.findIndex(cheque => cheque.url === this.state.current)
    cheques[currentIndex] = Object.assign({}, cheques[currentIndex], { approved: false })

    let current = cheques.filter(cheque => typeof cheque.approved === 'undefined')[0]

    current = current ? current.url : ''

    this.setState({ cheques, current })
  }

  submit () {
    const cheques = this.state.cheques.filter(cheque => typeof cheque.approved !== 'undefined')
    const key = Toast.show({
      message: <ProgressBar intent={Intent.PRIMARY} />,
      iconName: 'endorsed',
      timeout: 0
    })

    request
      .post(API_BASE_URL + '/approveCheques')
      .send({ cheques, user: this.props.user })
      .then(json => {
        if (json.ok) {
          Toast.dismiss(key)
          Toast.show({
            message: 'Submission Complete',
            iconName: 'endorsed',
            intent: Intent.SUCCESS
          })
          this.setState({
            cheques: [],
            current: ''
          })
        } else {
          throw new Error('Failed to approve cheques')
        }
      })
      .catch(err => {
        console.log(err)
        Toast.dismiss(key)
        Toast.show({
          message: 'Oops! Something went wrong.',
          iconName: 'warning-sign',
          intent: Intent.DANGER
        })
      })
  }

  render () {
    return (
      <div className='approve-main'>
        {
          this.state.cheques.length > 0 &&
          <div className='pt-card approve-sidebar'
            id='approve-sidebar-ref'
          >
            {
            renderMenu(this.setCurrent, this.submit)(this.state.cheques, this.state.current)
            }
          </div>
        }
        <div className='approve-body'>
          {
          this.state.current
          ? <div className='approve-doc'>
            <div className='approve-buttons'>
              <Button
                disabled={
                  this.state.cheques
                    .find(cheque => cheque.url === this.state.current)
                    .approved
                }
                className='pt-large'
                intent={Intent.SUCCESS}
                iconName='endorsed'
                text='Approve'
                onClick={() => this.approveCurrent()}
                />
              <Button
                disabled={
                  this.state.cheques
                    .find(cheque => cheque.url === this.state.current)
                    .approved === false
                }
                className='pt-large'
                intent={Intent.DANGER}
                iconName='ban-circle'
                text='Reject'
                onClick={() => this.rejectCurrent()}
                />
            </div>
            <div className='approve-doc-pdf'>
              <Document
                file={this.state.current}
                loading={
                  <div className='approve-doc-loading'>
                    <NonIdealState
                      visual='document-open'
                      title='Loading!'
                    />
                  </div>
                }
              >
                <Page pageNumber={1}
                  width={
                    // Prevent huge pdf below desktop
                    document.body.offsetWidth < 1024
                    ? document.getElementById('approve-sidebar-ref')
                    .getBoundingClientRect()
                    .width : null
                  }
                />
              </Document>
            </div>
          </div>
          : <div>
            <NonIdealState
              visual='oil-field'
              title='All Done!'
              description='There are no pending blank cheques.'
              />
          </div>
      }</div>
      </div>
    )
  }
}

export default withRouter(Approve)



// WEBPACK FOOTER //
// ./src/Private/Approve/Approve.js